module.exports = __webpack_public_path__ + "img/imagem.6ffdb8e4.svg";